import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faBoxOpen} from '@fortawesome/free-solid-svg-icons';
import {Resource} from 'app/constants/resource';
import {ENTITIES_SETUP_BASE_URL, ENTITIES_TARIFFS_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {CustomGoodsTypeProperty} from 'app/blocks/model/custom-goods-type-property';
import {ICustomGoodsTypeProperty} from 'app/blocks/model/custom-goods-type-property';
import {CustomGoodsTypePropertyService} from 'app/blocks/service/api/custom-goods-type-property.service';

@Injectable({
    providedIn: 'root'
})
export class CustomGoodsTypePropertyResource extends AbstractEntityResource<ICustomGoodsTypeProperty> {
    constructor(customGoodsTypePropertyService: CustomGoodsTypePropertyService, router: Router) {
        super(
            Resource.CUSTOM_GOODS_TYPE_PROPERTIES,
            customGoodsTypePropertyService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CUSTOM_GOODS_TYPE_PROPERTIES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CUSTOM_GOODS_TYPE_PROPERTIES),
            (entity?) => new CustomGoodsTypeProperty(entity),
            (entity) => entity.name,
            faBoxOpen
        );
    }
}
